import { merchantApi } from '@/config/axios'

// ========== 商家端子账号管理 API ==========

// 子账号分页
export const getSubAccountPage = (params: any) => {
  return merchantApi.get({ url: '/merchant-api/member/sub-account/page', params })
}

// 子账号详情
export const getSubAccount = (id: number) => {
  return merchantApi.get({ url: `/merchant-api/member/sub-account/get?id=${id}` })
}

// 创建子账号
export const createSubAccount = (data: any) => {
  return merchantApi.post({ url: '/merchant-api/member/sub-account/create', data })
}

// 更新子账号
export const updateSubAccount = (data: any) => {
  return merchantApi.put({ url: '/merchant-api/member/sub-account/update', data })
}

// 删除子账号
export const deleteSubAccount = (id: number) => {
  return merchantApi.delete({ url: `/merchant-api/member/sub-account/delete?id=${id}` })
}
